/**
 * @fileoverview Shared context lifting the sidebar's expanded-items state out of
 * `SidebarNavList` so controls living elsewhere in the layout (e.g. the app bar's
 * "Collapse all" button) can read and drive it.
 */

import * as React from 'react';

/**
 * Shared sidebar expansion state and helpers.
 */
export interface SidebarExpansion {
  /** Ids of the currently expanded (depth 0) navigation groups, e.g. `page-0-7`. */
  expandedItemIds: string[];
  /** Setter for {@link SidebarExpansion.expandedItemIds}. */
  setExpandedItemIds: React.Dispatch<React.SetStateAction<string[]>>;
  /** Collapses every expanded group by clearing the expanded ids. */
  collapseAll: () => void;
  /** `true` when at least one group is expanded. */
  anyExpanded: boolean;
}

/**
 * Context providing the lifted sidebar expansion state. `null` when no provider
 * is mounted, in which case consumers should fall back to local state.
 */
export const SidebarExpansionContext = React.createContext<SidebarExpansion | null>(null);
